module.exports = __webpack_public_path__ + "static/media/Joy.9136315b.jpg";